import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ breakpoints }) => ({
    sliderContainer: {
        position: "relative",
        display: "grid",
        gridTemplateColumns: "auto",
    },
    slide: {
        height: "65vh"
    },
    progress: {
        background: 'none',
        justifySelf: 'center',
        position: "absolute",
        bottom: "2%",
    },
}))

export default useStyles;